import * as z from 'zod'
import { commitSchema } from '../../../commit'

// base
const baseWorkflowSchema = z.object({ timestamp: z.string() })

export const commitPayloadSchema = baseWorkflowSchema.extend({
  type: z.literal('commit.created'),
  data: commitSchema,
})

export const listBlockPayloadSchema = baseWorkflowSchema.extend({
  type: z.enum([
    'list-block.created',
    'list-block.updated',
    'list-block.deleted',
  ]),
  data: z.object({
    listBlockId: z.string(),
    listBlockTitle: z.string().nullish(),
    blockId: z.string(),
  }),
})

export const eventBlockPayloadSchema = baseWorkflowSchema.extend({
  type: z.enum(['event-block.created']),
  data: z.object({
    eventBlockId: z.string(),
    eventBlockTitle: z.string(),
    parentBlockId: z.string().default(''), // backwards compatibility
    data: z.any().nullable(),
  }),
})

export const layoutBlockPayloadSchema = baseWorkflowSchema.extend({
  type: z.enum(['layout-block.updated']),
  data: z.object({
    layoutBlockId: z.string().default(''),
    updatedBlockId: z.string().default(''),
    userId: z.string().nullable().default(''),
  }),
})

export type LayoutBlockPayload = z.infer<typeof layoutBlockPayloadSchema>

export const blockPayloadSchema = baseWorkflowSchema.extend({
  type: z.enum(['block.updated']),
  data: z.object({ blockId: z.string(), blockIdPath: z.string() }),
})

export type BlockPayload = z.infer<typeof blockPayloadSchema>

export const workflowPayloadSchema = z.union([
  commitPayloadSchema,
  listBlockPayloadSchema,
  eventBlockPayloadSchema,
  layoutBlockPayloadSchema,
  blockPayloadSchema,
])

export type WorkflowPayload = z.infer<typeof workflowPayloadSchema> & {
  count?: number
}
